angular
	.module 'App.Repository'

.factory 'PromotionRepository', ['BaseRepository', (BaseRepository) ->
	class PromotionRepository extends BaseRepository
		@resource = '/promotion_campaigns'
		@isRestricted = true

	return new PromotionRepository
]
